"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "displayClassNames", {
    enumerable: true,
    get: function() {
        return _useDisplayStylesstyles.displayClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Display"), exports);
const _useDisplayStylesstyles = require("./useDisplayStyles.styles");
